import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { addAction } from '@/redux/store/information';
import UploadImg from '@/pages/components/uploadImg';
import alert from '@/pages/components/common/alert';
import ActionSheet from '@/pages/components/common/ui/actionsheet';
import '../scss/index.scss';

class EditCustomer extends React.Component <any, any>  {
	constructor(props: any) {
		super(props);
		this.state = {
			customers: [],
			name: '',
			url: '',
			logo: '',
			showForm: false, // 显示表单
			type: '', // 操作行为
			updateIndex: -1,
		}
	}

	componentDidMount() {
		// console.log(this.props)
		if(this.props.customers && this.props.customers.length > this.state.customers.length) {
			this.setState({
				customers: [...this.props.customers],
			})
		}
	}

	render() {
		return (
			<div className="gray-bg">
				<ActionSheet project="store" />
				<div className="menu-list-warrper">
					<ul className="menu-list">
						{
							this.state.customers.map((v: any, k: number) => {
								return (
									<li className="item" key={k} onClick={() => this.updateData(v)}>
										<span className="text">{v.name}</span>
										<i className="right-icon"></i>
									</li>
								)
							})
						}
					</ul>
				</div>
				<div className="menu-list-warrper mt-20">
					<ul className="menu-list">
						<li className="item" onClick={() => this.addData()}>
							<i className="add-icon"></i>
							<span className="text blue">新增优选客户</span>
							<i className="right-icon"></i>
						</li>
					</ul>
				</div>
				<p className="menu-prompt mt-20">最多添加5个</p>
				<div className="default-btn-warrper">
					<button className="default-btn" onClick={() => this.onComfirm()}>确定</button>
				</div>
				{
					this.state.showForm ?
					<div className="gray-bg fixed-mybox">
						<div className="default-form">
							<div className="form-input-warrper">
								<label className="label"><span className="red">*</span>企业名称</label>
								<input
									type="text" 
									placeholder="请输入企业名称" 
									className="text-right" 
									value={this.state.name}  
									onChange={ (e:any) => this.changeState('name', e.target.value) }/>
								
							</div>
							<div className="form-upload-warrper">
								<label className="label"><span className="red">*</span>企业LOGO </label>
								<div className="form-upload">
									<UploadImg sucess={(data: any) => this.changeState('logo', data)}  id={this.state.logo} />
								</div>
							</div>
							<div className="form-input-warrper">
								<label className="label">企业链接</label>
								<input
									type="text" 
									placeholder="请输入企业链接" 
									className="text-right" 
									value={this.state.url}  
									onChange={ (e:any) => this.changeState('url', e.target.value) }/>
								
							</div>
						</div>
						<div className="default-btn-warrper">
							<button className="default-btn" onClick={() => this.submitForm()}>确定</button>
							{
								this.state.type === 'update' ? <button className="default-btn waring-btn" onClick={() => this.removeData()}>删除</button> : ''
							}
						</div>
					</div> : ''
				}
			</div>
		)
	}
	// 更新state
	private changeState(k: string, v: any) {

		this.setState({
			[k]: v,
		});

	}

	// 更新state
	private changeInfoState(k:string, v:any) {
		(this.props as any).addAction({
			[k]: v
		})
	}

	private addData() {

		if(this.state.customers.length >= 5) {
			alert.open({
				promptText: '最多添加5个！'
			})
			return ;
		}

		this.setState({
			type: 'add',
			showForm: true
		})
	}

	private updateData(v: any) {
		var index =  this.state.customers.findIndex((v2: any) => {
			return v2.name === v.name
		})

		this.setState({
			type: 'update',
			showForm: true,
			name: v.name,
			url: v.url,
			logo: v.logo,
			updateIndex: index
		})
	}

	private removeData() {

		this.state.customers.splice(this.state.updateIndex,1);

		this.setState({
			customers: this.state.customers,
			name: '',
			url: '',
			logo: '',
			updateIndex: -1,
			showForm: false
		})
	}
 
	private submitForm() {
		if(!this.state.name) {
			alert.open({
				promptText: '企业名称不能为空！'
			})
			return ;
		}
		if(!this.state.logo) {
			alert.open({
				promptText: '企业LOGO不能为空！'
			})
			return ;
		}

		var index =  this.state.customers.findIndex((v: any) => {
			return v.name.replace(/\s*/g, '') === this.state.name
		})

		if(index !== -1 && index !== this.state.updateIndex) {
			alert.open({
				promptText: '企业名称已存在！'
			})
			return ;
		}
			
		
		if(this.state.type === 'add') {
			
			const obj = {
				name: this.state.name,
				url: this.state.url,
				logo: this.state.logo
			};
			
			this.setState({
				customers: [...this.state.customers, obj],
				showForm: false,
				name: '',
				url: '',
				logo: '',
			})
		}else if(this.state.type === 'update') {


			this.state.customers[this.state.updateIndex] = {
				name: this.state.name,
				url: this.state.url,
				logo: this.state.logo
			};

			// console.log(this.state.customers, 'this.state.type')
			this.setState({
				customers: this.state.customers,
				showForm: false,
				updateIndex: -1,
				name: '',
				url: '',
				logo: '',
			})
		}
	}

	private onComfirm() {
		this.changeInfoState('customers', this.state.customers);
		this.goForm()
	}

	private goForm() {
		(this.props as any).history.goBack(-1)
	}
}


const mapStateToProps = ( state: any ) => {
    return {
        ...state.storeInformationReducer
    };
};

const mapDispatchToProps = ( dispatch: Dispatch ) => {
    return bindActionCreators({addAction }, dispatch);
};

export default connect( mapStateToProps, mapDispatchToProps )(EditCustomer);